// extracted by mini-css-extract-plugin
export default {"PageConnector":"PageConnector_PageConnector__rAlnq"};